const SignInLogo = ({ color }: { color?: string }) => (
  <svg width={41} height={42} fill="none">
    <rect width={41} height={41} y={0.488} fill="url(#a)" rx={10} />
    <path
      stroke="#fff"
      strokeWidth={2.696}
      d="M11.688 15.768v4.262c0 1.455.611 2.844 1.685 3.826l7.127 6.516m0 0v3.021m0-3.021 7.127-6.516a5.184 5.184 0 0 0 1.686-3.826v-4.262"
    />
    <path
      stroke="#fff"
      strokeWidth={3.11}
      d="M20.504 16.804v8.295M20.5 10.584l3.142 1.814v3.629L20.5 17.84l-3.143-1.814v-3.63l3.143-1.813Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={0}
        x2={41}
        y1={20.988}
        y2={20.988}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color || '#A93438'} />
        <stop offset={1} stopColor={color || '#D13E43'} />
      </linearGradient>
    </defs>
  </svg>
)
export default SignInLogo
